
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import Color from '../../../../node_modules/color/index.js';
import { colors } from '../colors.js';

var tag = {
  backgroundColor: Color(colors.primary.lightest).alpha(0.25).string(),
  color: colors.primary.base
};

export { tag as default };
//# sourceMappingURL=tag.js.map
